"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequestIssue = void 0;
// FIXME: fromJSON版があるので削除できる
const immutable_1 = require("immutable");
const ModificationRequest_1 = require("../entity/ModificationRequest");
const modificationRequestIssueComment_1 = require("./modificationRequestIssueComment");
const createSomeModificationRequestIssue = ({ id = '12345', name = 'Modification Request Issue Name', comments = immutable_1.List([modificationRequestIssueComment_1.createSomeModificationRequestIssueComment(), modificationRequestIssueComment_1.createSomeModificationRequestIssueComment()]), resolved = false, } = {}) => new ModificationRequest_1.ModificationRequestIssue({
    id,
    name,
    comments,
    resolved,
});
exports.createSomeModificationRequestIssue = createSomeModificationRequestIssue;
